<ng-template #modalCreateTask let-modal class="modal-dialog-centered">
    <app-ui-preloader id="spinner" [display]="loading"></app-ui-preloader>
    <div class="modal-header ">
        <h4 class="modal-title" id="modalLabel">
            {{subTask ? ('BOARD.SUBTASK' | translate) : ('BOARD.TASK' | translate)}}
        </h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" [disabled]="loading"
            (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="taskForm" class="form row p-2">
            <div *ngIf="projectRequest" class="col col-12 col-xs-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.REQUIREMENT' | translate }}</label>
                <ngx-select [allowClear]="true" [attr.disabled]="loading" formControlName="requirementId"
                    [items]="requirementsList" (focus)="loadRequirements()" optionTextField="description"
                    optionValueField="value">
                    <ng-template ngx-select-option ngx-select-option-selected let-option>
                        <div>
                            <b>{{option.data.requirement}}</b>
                            &nbsp;
                            <small>({{option.data.group.name}})</small>
                        </div>
                        <div class="select-requirement">{{option.data.description}}</div>
                    </ng-template>

                    <ng-template ngx-select-option-not-found let-input>
                        "{{input}}" not found
                    </ng-template>
                </ngx-select>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.TITLE' | translate }} <span class="text-error">*</span></label>
                <input type="text" class="form-control" [readOnly]="loading" formControlName="title" required
                    [ngClass]="{ 'is-invalid': submittedTask && formTask.title.invalid}">
                <div class="form-validation" *ngIf="submittedTask && formTask.title.errors?.required">
                    {{ 'BOARD.FORM.TITLEERROR' | translate }}
                </div>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 checkB mb-1">
                <div class="form-check  form-switch" style="padding-left: 17px !important">
                    <input type="checkbox" class="form-check-input check-padding" [readOnly]="loading"
                        formControlName="plannedTask">
                    <label style="margin-left: 0" class="form-check-label text-primary">{{'BOARD.FORM.PLANNEDTASK'
                        |translate}}</label>
                </div>
            </div>
            <div class="col col-12 col-xs-12 col-md-12 col-lg-12 mb-2">
                <label class="form-label">{{ 'BOARD.FORM.DESCRIPTION' | translate }}</label>
                <textarea class="form-control" [readOnly]="loading" formControlName="description"></textarea>
            </div>
            <div class="col col-12 col-xs-12 col-md-12 col-lg-12 mb-2" style="text-align: center">
                <div class="btn btn-primary btn-action m-auto  btnSaveBottom btnSaveMinW2"
                    (click)="this.showModalFiles()">
                    <i class="mdi mdi-file-upload-outline"></i>
                    {{ 'MISC.FILESUP' | translate }}
                    <span class="badge bg-danger rounded-circle noti-icon-badge" [attr.disabled]="loading"
                        style="margin-left: 5px;">{{formTask.files.value.length}}</span>
                </div>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.SCRUMCOLUMN' | translate }}</label>
                <ngx-select [allowClear]="true" formControlName="columnId" appendTo="body" [items]="columnsList"
                    [attr.disabled]="loading" (focus)="loadColumns()"
                    [ngClass]="{ 'is-invalid': submittedTask && formTask.columnId.invalid}">
                </ngx-select>
                <a class="a-link" (click)="openModalColumn()" [attr.disabled]="loading">
                    <i class="mdi mdi-plus-circle"></i>
                    {{'BOARD.FORM.ADDCOLUMN' | translate}}
                </a>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3">
                <label class="form-label">{{ 'BOARD.FORM.SPRINT' | translate }}</label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="sprintId" [items]="sprintsList"
                    [attr.disabled]="loading" (focus)="loadSprints()" (select)="loadDataFilters()"
                    (remove)="clearAssignedTo()">
                </ngx-select>
                <a class="a-link" (click)="openModalSprint()" [attr.disabled]="loading">
                    <i class="mdi mdi-plus-circle"></i>
                    {{'BOARD.FORM.ADDSPRINT' | translate}}
                </a>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.TYPE' | translate }}
                    <span class="text-error">*</span></label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="typeId" [items]="typesList"
                    (focus)="loadTypes()" [attr.disabled]="loading"
                    [ngClass]="{ 'is-invalid': submittedTask && formTask.typeId.invalid}">
                </ngx-select>
                <div class="form-validation" *ngIf="submittedTask && formTask.typeId.errors?.required">
                    {{ 'BOARD.FORM.TYPEERROR' | translate }}
                </div>
                <a class="a-link" (click)="openModalEvent()" [attr.disabled]="loading">
                    <i class="mdi mdi-plus-circle"></i>
                    {{'BOARD.FORM.ADDTYPE' | translate}}
                </a>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3">
                <label class="form-label">{{ 'BOARD.FORM.PRIORITY' | translate }}
                    <span class="text-error">*</span></label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="priorityId" [items]="prioritiesList"
                    [attr.disabled]="loading" (focus)="loadPriorities()"
                    [ngClass]="{ 'is-invalid': submittedTask && formTask.priorityId.invalid}">
                </ngx-select>
                <div class="form-validation" *ngIf="submittedTask && formTask.priorityId.errors?.required">
                    {{ 'BOARD.FORM.PRIORITYERROR' | translate }}
                </div>
                <a class="a-link" (click)="openModalPriority()" [attr.disabled]="loading">
                    <i class="mdi mdi-plus-circle"></i>
                    {{'SETTINGS.PRIORITY.ADDPRIORITY' | translate}}
                </a>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.STARTDATE' | translate }}</label>
                <p-calendar formControlName="startDate" styleClass="input-group" (onSelect)="validateDates()"
                    (onTodayClick)="validateDates()" inputStyleClass="form-control" dateFormat="yy-mm-dd"
                    [minDate]="minDate" [maxDate]="maxDate" appendTo="body" [showIcon]="true"
                    icon="mdi mdi-calendar-month" [showButtonBar]="true" [autoZIndex]="true" [baseZIndex]="1000999999">
                </p-calendar>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3">
                <label class="form-label">{{ 'BOARD.FORM.ENDDATE' | translate }}</label>
                <p-calendar formControlName="endDate" styleClass="input-group" (onSelect)="validateDates()"
                    (onTodayClick)="validateDates()" inputStyleClass="form-control" dateFormat="yy-mm-dd"
                    [minDate]="minDate" [maxDate]="maxDate" appendTo="body" [showIcon]="true"
                    icon="mdi mdi-calendar-month" [showButtonBar]="true" [autoZIndex]="true" [baseZIndex]="1000999999">
                </p-calendar>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3 ">
                <label class="form-label w">{{'BOARD.FORM.ESTIMATEDTIME' | translate}}</label>
                <p-inputMask slotChar="_" inputStyleClass="form-control" styleClass="input-group"
                    formControlName="estimatedDuration" mask="99:99 h" [readonly]="loading"></p-inputMask>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-3">
                <label class="form-label">{{ 'BOARD.FORM.ASSIGNEDTO' | translate }}</label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="assignedId" [items]="usersList"
                    (focus)="loadUsers(null)" (typed)="loadUsers($event)" [attr.disabled]="loading"
                    [ngClass]="{ 'is-invalid': submittedTask && formTask.assignedId.invalid}">
                </ngx-select>
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">{{ 'BOARD.FORM.REQUESTEDBY' | translate }}</label>
                <input type="text" class="form-control" [readOnly]="loading" formControlName="requestedBy">
            </div>
            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 ">
                <label class="form-label">{{ 'BOARD.FORM.AREA' | translate }}</label>
                <p-chips appendTo="body" styleClass="input-group" inputStyleClass="form-control"
                    [placeholder]="translateService.instant('BOARD.TAGS')" formControlName="tags" separator=",">
                </p-chips>
            </div>

            <div class="col col-12">

                <label class="form-label">{{ 'BOARD.FORM.ORDERTYPE' | translate }}</label>
                <i class="mdi mdi-information iconMoreInfo" (click)="op.toggle($event)"></i>

                <ngx-select appendTo="body" [allowClear]="false" formControlName="isBefore" [items]="orderTypesList"
                    [attr.disabled]="loading">
                </ngx-select>
            </div>

            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 mb-1"
                *ngIf="taskForm.value.isBefore == false || taskForm.value.isBefore == true ">
                <label class="form-label">{{ 'BOARD.FORM.COLUMNTYPE' | translate }}</label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="taskColumnId" [items]="taskColumnsList"
                    (focus)="loadTasksColumn(null)" (typed)="loadTasksColumn($event)" [attr.disabled]="loading">
                </ngx-select>
            </div>

            <div class="col col-6 col-xs-6 col-md-6 col-lg-6 mb-1"
                *ngIf="taskForm.value.isBefore == false || taskForm.value.isBefore == true ">
                <label class="form-label">{{ 'BOARD.FORM.SPRINTTYPE' | translate }}</label>
                <ngx-select appendTo="body" [allowClear]="true" formControlName="taskSprintId" [items]="taskSprintsList"
                    (focus)="loadTasksSprint(null)" (typed)="loadTasksSprint($event)" [attr.disabled]="loading">
                </ngx-select>
            </div>
        </form>
    </div>

    <div class="mt-2 mb-2 d-flex justify-content-center">

        <button class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2" [disabled]="loading"
            (click)="saveTask(modal)">
            {{'MISC.SAVE'| translate}}
        </button>
    </div>

    <p-overlayPanel appendTo="body" [showCloseIcon]="true" #op [baseZIndex]="999999999999">
        <ng-template pTemplate>
            <div>
                <ul class="listType">
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER1' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER2' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER3' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER4' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER5' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER6' | translate}}</li>
                    <li>{{'BOARD.FORM.OPTIONSLIST.ORDER7' | translate}}</li>
                </ul>
            </div>

        </ng-template>
    </p-overlayPanel>


</ng-template>

<!-- Modal Files -->
<app-modal-files #modal [onlyPreview]="false" (saveModal)="saveNeedFiles($event)"
    (closeModal)="this.showModal = false; showModalRequestFiles ? showModalRequestFiles = false : null;">
</app-modal-files>
<!-- end Modal Files -->

<!-- Priority Modal -->
<app-priority-modal #modalPriority></app-priority-modal>
<!-- end Priority Modal -->

<!-- Modal Event -->
<app-event-modal #modalEvent></app-event-modal>

<app-column-modal #modalColumn></app-column-modal>
<!-- end Modal Column -->